export default {
	title: "Delete KR?",
	description: "This action cannot be undone.",
	confirmButton: "Delete KR",
	dismissButton: "Do not delete",
};
